<script setup>
import {computed, onMounted, reactive} from "vue";
import { useStore } from "vuex";
import {useI18n} from "vue-i18n";
import {countPointsApi, stripe_API, accessControlApi, cancellationApi} from "@/api/forwriting_index";
import router from "@/router";


const { t, locale } = useI18n();

const formatLocalizedDate = (value) => {
  if (!value) return ""
  const localeCode = locale.value === "tw" ? "zh-TW" : "ja-JP"
  return new Date(value).toLocaleDateString(localeCode)
}

// 取出 query string
const params = new URLSearchParams(window.location.search)
const status = params.get('status')

if (status === 'success') {
  console.log( "status: 設定付款方式成功")

  const session_id = params.get('session_id')
  console.log( "*** session_id", session_id)

  // todo: 在這裡加入後續動作
}
else if (status === 'cancel') {
  console.log( "status: 設定付款方式失敗")
  // todo: 在這裡加入後續動作
}

const store = useStore();
const canManagePlan = computed(() => {
  const roles = store.getters.stateUser?.roles || [];
  return roles.some(role => ["システム管理者", "管理者ユーザー", "admin"].includes(role.role_name));
});

const data = reactive({
  plan: {
    plan_name: "",
    plan_monthly_price: 0,
    base_points: 0,
    point_limit: 0,
    point_price: 0,
    // 日割り情報
    is_prorated_this_month: false,
    proration_factor: 1.0,
    display_monthly_price: 0,
    display_base_points: 0,
    period_days: 30,
    active_days: 30,
  },

  monthly_points: [],

  monthly_points_id: 0,
  
  // モーダル表示状態
  showPlanModal: false,
  showCancelModal: false,
  
  // プラン状態
  planStatus: {
    plan_name: "",
    plan_id: 0,
    is_cancelled: false,
    cancelled_at: null,
    is_active: true,
    can_cancel: false,
    start_date: null,
    end_date: null
  },
  tenant_id: computed( ( ) => {
    return data.monthly_points[ data.monthly_points_id]?.tenant_id
  }),
  total_points: computed( ( ) => {
    return data.monthly_points[ data.monthly_points_id]?.total_points || 0
  }),
  over_points: computed( ( ) => {
    return data.monthly_points[data.monthly_points_id]?.over_points || 0
  }),
  billing_amount: computed( ( ) => {
    // バックエンドから返される値がある場合はそれを使用
    const backend_amount = data.monthly_points[ data.monthly_points_id]?.billing_amount
    if (backend_amount !== undefined && backend_amount !== null) {
      return backend_amount
    }
    // 記事生成を1回もしていない場合は基本料金 + 超過料金で計算
    const base_fee = data.plan.is_prorated_this_month ? data.plan.display_monthly_price : data.plan.plan_monthly_price
    const over_fee = (data.over_points || 0) * (data.plan.point_price || 0)
    return base_fee + over_fee
  }),
})

// 日割り表示用のcomputed
const displayPrice = computed(() => {
  if (data.plan.is_prorated_this_month) return data.plan.display_monthly_price
  return data.plan.plan_monthly_price
})

const displayBasePoints = computed(() => {
  if (data.plan.is_prorated_this_month) return data.plan.display_base_points
  return data.plan.base_points
})

const onChange_monthly_points_id = async( ) => {
  console.log( "monthly_points_id:", data.monthly_points_id)
}

onMounted(async () => {
  // アクセス権限チェック
  if (!await accessControlApi.check_option_access()) {
    await router.push(`/forwriting/options_error`)
    return
  }

  const resp_plan = await countPointsApi.get_plan()
  console.log( "resp_plan:", resp_plan.data)
  data.plan = resp_plan.data

  const resp_monthly_points = await countPointsApi.get_monthly_points()
  console.log( "resp_monthly_points:", resp_monthly_points.data)
  data.monthly_points = resp_monthly_points.data || []

  // プラン状態を取得
  try {
    const resp_plan_status = await cancellationApi.get_plan_status()
    console.log( "plan_status:", resp_plan_status.data)
    data.planStatus = resp_plan_status.data
  } catch (error) {
    console.error("プラン状態取得エラー:", error)
  }

  // 判斷是那個 plan
})

const register_standard_plan = async( ) => {
  console.log( "register_standard_plan()...")
  data.showPlanModal = true
}

const proceedToStripe = async() => {
  console.log( "proceedToStripe()...")

  const tenant_id = data.tenant_id
  console.log( "tenant_id:", tenant_id)

  const resp = await stripe_API.get_checkout_url()
  const url = resp.data
  console.log( "url:", url)
  window.location.href = url.toString()
}

const closePlanModal = () => {
  data.showPlanModal = false
}

const showCancelModal = () => {
  data.showCancelModal = true
}

const closeCancelModal = () => {
  data.showCancelModal = false
}

const cancelPlan = async () => {
  try {
    const resp = await cancellationApi.cancel_plan()
    console.log("解約レスポンス:", resp.data)
    
    if (resp.data.message === "cancelled_successfully") {
      alert(t("usage.cancel_success"))
      // プラン状態を再取得
      const resp_plan_status = await cancellationApi.get_plan_status()
      data.planStatus = resp_plan_status.data
    } else if (resp.data.message === "already_cancelled") {
      alert(t("usage.already_cancelled"))
    }
    
    data.showCancelModal = false
  } catch (error) {
    console.error("解約エラー:", error)
    alert(t("usage.cancel_error"))
  }
}

</script>

<template>

  <!-- modal_over_points -->
  <div v-if="data.plan.plan_name==='Trial'" class="msg-container"
  style="background-color: rgb(231,249,255)">
    <table>
      <tbody>
      <tr>
        <td style="width: 58%; text-align: center"
        >{{$t( "usage.use_trial_plan_now")}}。</td>
        <td style="text-align: center">
          <button class="btn btn-primary" style="width: 280px"
          v-if="canManagePlan"
          @click="register_standard_plan">
          {{$t( "usage.register_standard_plan")}}</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <!-- end of modal_over_points -->

  <!-- Standard plan signup modal -->
  <div v-if="data.showPlanModal" class="modal-overlay" @click="closePlanModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>{{ $t("usage.plan_modal_title") }}</h3>
        <button class="close-btn" @click="closePlanModal">&times;</button>
      </div>
      
      <div class="modal-body">
        <div class="plan-info">
          <h4>{{ $t("usage.plan_basic_info") }}</h4>
          <table class="plan-table">
            <tbody>
              <tr>
                <td class="plan-label">{{ $t("usage.plan_name_label") }}</td>
                <td class="plan-value">{{ $t("usage.standard_plan_name") }}</td>
              </tr>
              <tr>
                <td class="plan-label">{{ $t("usage.monthly_fee_label") }}</td>
                <td class="plan-value">{{ $t("usage.monthly_fee_value") }}</td>
              </tr>
              <tr>
                <td class="plan-label">{{ $t("usage.points_granted_label") }}</td>
                <td class="plan-value">{{ $t("usage.points_granted_value") }}</td>
              </tr>
              <tr>
                <td class="plan-label">{{ $t("usage.extra_fee_label") }}</td>
                <td class="plan-value">{{ $t("usage.extra_fee_value") }}</td>
              </tr>
            </tbody>
          </table>
          
          <h4>{{ $t("usage.contract_billing_info") }}</h4>
          <table class="plan-table">
            <tbody>
              <tr>
                <td class="plan-label">{{ $t("usage.contract_period_label") }}</td>
                <td class="plan-value">{{ $t("usage.contract_period_value") }}</td>
              </tr>
              <tr>
                <td class="plan-label">{{ $t("usage.proration_label") }}</td>
                <td class="plan-value">{{ $t("usage.proration_value") }}</td>
              </tr>
              <tr>
                <td class="plan-label">{{ $t("usage.payment_method_label") }}</td>
                <td class="plan-value">{{ $t("usage.payment_method_value") }}</td>
              </tr>
              <tr>
                <td class="plan-label">{{ $t("usage.billing_timing_label") }}</td>
                <td class="plan-value">{{ $t("usage.billing_timing_value") }}</td>
              </tr>
              <tr>
                <td class="plan-label">{{ $t("usage.cancel_policy_label") }}</td>
                <td class="plan-value">{{ $t("usage.cancel_policy_value") }}</td>
              </tr>
            </tbody>
          </table>
          
          <h4>{{ $t("usage.usage_points_info") }}</h4>
          <div class="points-info">
            <p><strong>{{ $t("usage.points_usage_target_label") }}</strong>{{ $t("usage.points_usage_target_value") }}</p>
            <p><strong>{{ $t("usage.points_rules_label") }}</strong></p>
            <div class="points-table">
              <div class="points-row">
                <span class="points-range">{{ $t("usage.points_range_1") }}</span>
                <span class="points-cost">{{ $t("usage.points_cost_1") }}</span>
              </div>
              <div class="points-row">
                <span class="points-range">{{ $t("usage.points_range_2") }}</span>
                <span class="points-cost">{{ $t("usage.points_cost_2") }}</span>
              </div>
              <div class="points-row">
                <span class="points-range">{{ $t("usage.points_range_3") }}</span>
                <span class="points-cost">{{ $t("usage.points_cost_3") }}</span>
              </div>
              <div class="points-row">
                <span class="points-range">{{ $t("usage.points_range_4") }}</span>
                <span class="points-cost">{{ $t("usage.points_cost_4") }}</span>
              </div>
            </div>
            <ul class="points-rules">
              <li>{{ $t("usage.points_rollover") }}</li>
              <li>{{ $t("usage.points_check_method") }}</li>
            </ul>
          </div>
        </div>
        
        <div class="notice-section">
          <p class="notice-text">
            {{ $t("usage.notice_1_line_1") }}<br>
            {{ $t("usage.notice_1_line_2") }}
          </p>
          <p class="notice-text">
            {{ $t("usage.notice_2_line_1") }}<br>
            {{ $t("usage.notice_2_line_2") }}
          </p>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closePlanModal">{{ $t("usage.cancel_button") }}</button>
        <button class="btn btn-primary" @click="proceedToStripe">
          {{ $t("usage.register_standard_plan_cta") }}
        </button>
      </div>
    </div>
  </div>
  <!-- end of standard plan signup modal -->

  <!-- Cancellation confirmation modal -->
  <div v-if="data.showCancelModal" class="modal-overlay" @click="closeCancelModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>{{ $t("usage.cancel_modal_title") }}</h3>
        <button class="close-btn" @click="closeCancelModal">&times;</button>
      </div>
      
      <div class="modal-body">
        <div class="cancellation-info">
          <h4>{{ $t("usage.cancel_about_title") }}</h4>
          <ul class="cancellation-rules">
            <li>{{ $t("usage.cancel_rule_1") }}</li>
            <li>{{ $t("usage.cancel_rule_2") }}</li>
            <li>{{ $t("usage.cancel_rule_3") }}</li>
          </ul>
          
          <div class="warning-section">
            <p><strong>{{ $t("usage.warning_title") }}</strong></p>
            <p>{{ $t("usage.cancel_warning_text") }}</p>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeCancelModal">{{ $t("usage.cancel_button") }}</button>
        <button class="btn btn-danger" @click="cancelPlan">
          {{ $t("usage.execute_cancel") }}
        </button>
      </div>
    </div>
  </div>
  <!-- end of cancellation confirmation modal -->

  <!-- plan(Trial)-->
  <div v-if="data.plan.plan_name==='Trial'" class="msg-container">
    <div class="h5">{{$t( "usage.plan")}}</div>
    <table class="tb">
      <tbody>
      <tr>
        <td class="td-left">{{$t( "usage.plan_name")}}</td>
        <td class="td-right">{{$t( "usage.Trial")}}</td>
      </tr>

      <tr>
        <td class="td-left">{{$t( "usage.plan_monthly_price")}}</td>
        <td class="td-right">
          ¥{{displayPrice}} / 月
          ({{displayBasePoints}} {{$t( "usage.include_base_points")}})
          <span v-if="data.plan.is_prorated_this_month" style="margin-left:8px; font-size:12px; color:#666">
            {{ $t("usage.proration_badge", { percent: Math.round(data.plan.proration_factor*100), active_days: data.plan.active_days, period_days: data.plan.period_days }) }}
          </span>
        </td>
      </tr>

      <tr>
        <td class="td-left">{{$t( "usage.point_limit")}}</td>
        <td class="td-right">{{data.plan.point_limit}} {{$t( "usage.points")}}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <!-- plan(Standard)-->
  <div v-if="data.plan.plan_name==='Standard'" class="msg-container">
    <div class="h5">{{$t( "usage.plan")}}</div>
    <table class="tb">
      <tbody>

      <tr>
        <td class="td-left">{{$t( "usage.plan_name")}}</td>
        <td class="td-right">{{$t( "usage.Standard")}}</td>
      </tr>

      <tr>
        <td class="td-left">{{$t( "usage.plan_monthly_price")}}</td>
        <td class="td-right">
          ¥{{displayPrice}} / 月
          ({{displayBasePoints}} {{$t( "usage.include_base_points")}})
          <span v-if="data.plan.is_prorated_this_month" style="margin-left:8px; font-size:12px; color:#666">
            {{ $t("usage.proration_badge", { percent: Math.round(data.plan.proration_factor*100), active_days: data.plan.active_days, period_days: data.plan.period_days }) }}
          </span>
        </td>
      </tr>

      <tr>
        <td class="td-left">{{$t( "usage.point_price")}}</td>
        <td class="td-right">¥{{data.plan.point_price}} /
          1{{$t( "usage.points")}}</td>
      </tr>

      </tbody>
    </table>
    
    <!-- Cancel plan button -->
    <div v-if="data.planStatus.can_cancel && canManagePlan" style="margin-top: 20px; text-align: center;">
      <button class="btn btn-danger" @click="showCancelModal">
        {{ $t("usage.cancel_plan_button") }}
      </button>
    </div>
    
    <!-- Cancellation status -->
    <div v-if="data.planStatus.is_cancelled" style="margin-top: 20px; padding: 15px; background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px;">
      <p style="margin: 0; color: #856404;">
        <strong>{{ $t("usage.cancelled_status") }}</strong><br>
        {{ $t("usage.cancelled_date") }}: {{ formatLocalizedDate(data.planStatus.cancelled_at) }}<br>
        {{ $t("usage.cancelled_notice") }}
      </p>
    </div>
  </div>

  <!-- usage-->
  <div class="msg-container">
    <div class="h5">{{$t( "usage.usage")}}</div>

    <select class="form-select td-combo" style="width: 200px"
            @change="onChange_monthly_points_id"
            v-model="data.monthly_points_id">
      <option
          :value="index" v-for="(item, index) in data.monthly_points" :key="index">
        {{item.usage_month}}</option>
    </select>

    <table class="tb">
      <tbody>
      <tr>
        <td class="td-left">{{$t( "usage.total_points")}}</td>
        <td class="td-right font-large">{{data.total_points}}/
          {{displayBasePoints}} {{$t( "usage.points")}}</td>
      </tr>
      </tbody>
    </table>

  </div>

  <!-- charge-->
  <div class="msg-container">
    <div class="h5">{{$t( "usage.charge")}}</div>
    <table class="tb">
      <tbody>
      <tr>
        <td class="td-left">{{$t( "usage.plan_monthly_price")}}</td>
        <td class="td-right">
          ¥{{displayPrice}}
          <span v-if="data.plan.is_prorated_this_month" style="margin-left:8px; font-size:12px; color:#666">
            {{ $t("usage.proration_badge", { percent: Math.round(data.plan.proration_factor*100), active_days: data.plan.active_days, period_days: data.plan.period_days }) }}
          </span>
        </td>
      </tr>

      <tr>
        <td class="td-left">{{$t( "usage.over_billing")}}
          ({{data.over_points}} {{$t( "usage.points_number")}})</td>
        <td class="td-right">¥{{(data.over_points || 0) * (data.plan.point_price || 0)}}</td>
      </tr>

      </tbody>
    </table>
    <hr style="margin-left: 15px">
    <table class="tb">
      <tbody>

      <tr>
        <td class="td-left">{{$t( "usage.billing_amount")}}</td>
        <td class="td-right font-large">¥{{data.billing_amount}}</td>
      </tr>

      </tbody>
    </table>

  </div>

</template>

<style scoped>

.modal_over_points {
  width: 800px;
  border-radius: 6px;
  border: 1px solid rgb(238,126,92)
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  max-width: 1600px;  /* お好みに合わせて変更 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.msg-container {
  width: 80%;
  max-width: 800px;
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #f8f9fa;
}

.tb {
  margin-top: 20px;
  margin-left: 15px;
}

.td-left {
  text-align: left;
  width: 380px;
  font-size: 15px;
}

.td-right {
  text-align: left;
  width: 660px;
}

.font-large {
  font-size: 20px;
  font-weight: bold;
}

.td-combo {
  margin-top: 10px;
  margin-left: 10px;
  width: 320px;
}

/* モーダルスタイル */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.plan-info h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.plan-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.plan-table tr {
  border-bottom: 1px solid #f0f0f0;
}

.plan-table td {
  padding: 8px 0;
}

.plan-label {
  font-weight: 500;
  color: #666;
  width: 40%;
}

.plan-value {
  color: #333;
  font-weight: 600;
}

.points-info {
  margin-top: 15px;
}

.points-info p {
  margin: 10px 0;
  color: #333;
  font-size: 14px;
}

.points-table {
  margin: 10px 0;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.points-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #e0e0e0;
}

.points-row:last-child {
  border-bottom: none;
}

.points-range {
  color: #666;
  font-size: 13px;
}

.points-cost {
  color: #333;
  font-weight: 600;
  font-size: 13px;
}

.points-rules {
  margin: 15px 0 0 0;
  padding-left: 20px;
  color: #666;
  font-size: 13px;
}

.points-rules li {
  margin: 5px 0;
}

.notice-section {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  margin-top: 20px;
}

.notice-text {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

.notice-text:last-child {
  margin-bottom: 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
}

/* 解約モーダル用スタイル */
.cancellation-info {
  padding: 10px 0;
}

.cancellation-rules {
  margin: 15px 0;
  padding-left: 20px;
  color: #333;
  font-size: 14px;
}

.cancellation-rules li {
  margin: 8px 0;
  line-height: 1.4;
}

.warning-section {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 15px;
  margin-top: 20px;
}

.warning-section p {
  margin: 0 0 8px 0;
  color: #856404;
  font-size: 14px;
}

.warning-section p:last-child {
  margin-bottom: 0;
}

.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.btn-danger:hover {
  background-color: #c82333;
  border-color: #bd2130;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}

</style>